import './index.scss'

document.querySelectorAll('.advice_section__title').forEach(item => {
    item.addEventListener('click', () => {
        item.parentNode.querySelector('.advice_section_content').classList.toggle('active')
        item.classList.toggle('active')
    })
})

let price_btn = document.querySelectorAll('.filter_set_btn');

if (price_btn.length >= 1) {
    price_btn.forEach(element => {
        let data = `category=${element.dataset.slug}`;
        element.addEventListener('click', function () {
            filter_data(data);
        });
    });
}


let params = window
    .location
    .search
    .replace('?', '')
    .split('&')
    .reduce(
        function (p, e) {
            var a = e.split('=');
            p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
            return p;
        },
        {}
    );

updateFilter(params['category'], 'category', 'shop_sort_link_active');

function updateFilter(param, name, activeClass) {
    let hrefAttr = `[data-slug='${name}=${param}']`;
    let activeItem = document.querySelector(`.${activeClass}`);
    let currentItem = document.querySelector(hrefAttr);
    if (currentItem != null) {
        activeItem.classList.remove(activeClass);
        currentItem.classList.add(activeClass);
    }
}


const filter_data = (sort_cart) => {
    let array_url = [];
    let current_url;

    if (document.querySelector('.shop_sort_link_active')) {
        let sort = sort_cart ? sort_cart : `category=${document.querySelector('.shop_sort_link_active').dataset.slug}`;
        array_url.push(sort);
    }

    current_url = array_url.join('&');
    window.location = `?${current_url}`;
}

